const buildings = []

module.exports = {
    buildings: buildings
}

/////////////////////////
// EXAMPLE
// {
// 	"id": "way/334749673",
// 	"title": "Brinkley Building",
// 	"campus": "Davidson",
// 	"popup": {
// 		"title": "Brinkley Building",
// 		"linkedscenes": [
// 			{
// 				"scene": "scene_Davidson_Cosmopology",
// 				"title": "Davidson Cosmetology"
// 			},
// 			{
// 				"scene": "scene_Davidson_Gym",
// 				"title": "Davidson Gym"
// 			},
// 		],
// 		"driveLocation": {
// 			"lat": "35.86419184115513",
// 			"lng": "-80.1825960532508"
// 		}
// 	}
// },